import { Box, SxProps, Theme, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { ReactComponent as FlagDe } from '../../../../assets/images/flags/de.svg';
import { ReactComponent as FlagGb } from '../../../../assets/images/flags/gb.svg';
import { useTranslation } from 'react-i18next';
import MenuHeading from '../../../Typography/MenuHeading/MenuHeading';
import { t } from 'i18next';

interface Props {
  sx?: SxProps<Theme>;
}

const LanguageSwitch = ({ sx }: Props) => {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.resolvedLanguage);

  const handleChange = (event: MouseEvent<HTMLElement>, newLang: string) => {
    setLang(newLang);
    i18n.changeLanguage(newLang).catch((error) => console.error(error));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        px: theme.spacing(2),
        pb: theme.spacing(1),
        ...sx,
      }}
    >
      <MenuHeading
        text={t('language_head')}
        sx={{ px: 0 }}
      />
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <ToggleButtonGroup
          color="primary"
          size="small"
          value={lang}
          exclusive
          fullWidth
          onChange={handleChange}
          sx={{
            '& .Mui-selected.MuiToggleButtonGroup-grouped': {
              border: `1px solid ${theme.palette.primary.main}`,
            },
          }}
        >
          <ToggleButton value="de">
            <FlagDe
              width="32px"
              height="100%"
            />
          </ToggleButton>
          <ToggleButton value="en">
            <FlagGb
              width="32px"
              height="100%"
            />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default LanguageSwitch;
